import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import CHRAccordion from '../accordion'
import axios from '../../axios'
import { ENDPOINTS } from './../../constants'
import CHRSpinner from '../spinner'
import { Typography } from '@material-ui/core'

interface FaqTabProps {
  t: TFunction
}

interface FaqItemProps {
  title: string
  HTMLString: string
}

const FaqItem = ({ title, HTMLString }: FaqItemProps) => {
  return (
    <CHRAccordion title={title}>
      <article dangerouslySetInnerHTML={{ __html: HTMLString }} />
    </CHRAccordion>
  )
}

const FaqsTab = ({ t }: FaqTabProps) => {
  const [faqs, setFaqs] = useState([{}])
  const [status, setStatus] = useState({
    isLoading: false,
    message: '',
  })

  useEffect(() => {
    ;(async () => {
      setStatus({ message: '', isLoading: true })
      try {
        const response = await axios.get(ENDPOINTS.cms.replace(':name', 'faqs'))
        const faqs = JSON.parse(response.data.data.content).faqs
        setStatus({ message: '', isLoading: false })
        setFaqs(faqs)
      } catch (error) {
        setStatus({
          message: t('messages.somethingWentWrong'),
          isLoading: false,
        })
      }
    })()
  }, [])

  return (
    <>
      {status.isLoading ? (
        <CHRSpinner />
      ) : status.message ? (
        <Typography variant="h1" component="h6">
          {status.message}
        </Typography>
      ) : (
        faqs?.map((faq: { id: number; title: string; content: string }) => {
          return (
            <FaqItem key={faq.id} title={faq.title} HTMLString={faq.content} />
          )
        })
      )}
    </>
  )
}
export default withTranslation()(FaqsTab)
